<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Report Details</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <ViewAllReports />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
import ViewAllReports from "@/components/admin/ViewAllReports.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'viewAllReport',
    components: {
      ViewAllReports, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
    },
    data() {
        return {
            add
        }
    },
    methods: {
        navigatePreviousPage() {
        this.$router.go(-1)
        },
        
        addNewTariff() {
            this.$router.push("addNewTariff"); 
        }
    }
})
</script>